// extracted by mini-css-extract-plugin
var _1 = "partner-apis__4S3AY";
var _2 = "public-home-page__jSG5Z";
var _3 = "request-access__x26x4";
var _4 = "tenant-apis__Bnmp2";
var _5 = "welcome__VIa6m";
export { _1 as "partnerApis", _2 as "publicHomePage", _3 as "requestAccess", _4 as "tenantApis", _5 as "welcome" }
